// extracted by mini-css-extract-plugin
export default {"link":"ChatLink_link__AuM7W"};